import * as React from 'react';
import { Select, Row, Col, Checkbox, Divider,  } from 'antd';
import { getDatasetList, getData, getExploreMetaData, getRawData, getExploreIndividualData } from '../../../service/dataService';
import { assert_key_hier, assert_key, arraysEqual, setsAreEqual, get_mode_options,
    safe_extract_item_from_list, safe_extract_items_from_list } from '../../../helper';
import { extract_dataset_list, extract_api_list, 
    extract_task_list, extract_explore_dataset_list } from '../../../helper/preprocessor';
import { assert } from 'console';
const Option = Select.Option;

export interface DataSelectorProps {
    dataset_id : number | null,  // dataset id
    api_id : number | null,  // dummy item
    api_id_list: any, 
    mode_id: number,
    task_id: number | null,
    datasetList: any,   // dataset list
    changeDataset: any,  // change dataset
    changeAPI: any,     // dummy item
    changeAPIList:any, 
    changeTask:any, 
    changeMode:any, 
    changeExploreLoading: any,
    clearIdInfo:any,    // clear id info
    initDatasetList: any,  // initialize dataset list
    initData: any,
    initExploreMetaData: any,
    data:any,
    explore_meta_data:any,
    width: any
}

export interface DataSelectorState {
    selectState: boolean
}

export default class DataSelector extends React.Component<DataSelectorProps, DataSelectorState> {
    constructor(props: DataSelectorProps) {
        super(props);
        this.onDatasetSelectorChange = this.onDatasetSelectorChange.bind(this);
        this.onAPISelectorChange = this.onAPISelectorChange.bind(this);
        this.onAPIListSelectorChange = this.onAPIListSelectorChange.bind(this);
        this.onTaskSelectorChange = this.onTaskSelectorChange.bind(this);
        this.onModeSelectorChange = this.onModeSelectorChange.bind(this);
        this.initExploreIndividualData = this.initExploreIndividualData.bind(this);
        this.state = {
            selectState: false
        };
    }
    // Initialize Dataset List.
    componentDidMount(){
        this.initData();
        this.initExploreMetaData();
    }
    public async initExploreMetaData(){
        this.props.changeExploreLoading(true);
        const data_package = await getExploreMetaData();

        if(data_package["success"] === true){
            let data_package_spec = [{
                "n": "data",
                "c":[
                    {"n": "DatasetNames"}
                ]
            }];
            let flag = assert_key_hier(data_package, data_package_spec, true, "data_package");
            if(flag){
                console.log("explore meta package", data_package);
                this.props.initExploreMetaData(data_package["data"]);
                this.props.changeExploreLoading(false);
                // this.props.initDatasetList(data_package["datasets"]["DatasetsList"]);
            }
        }
        
    }
    public async initExploreIndividualData(dataset:any){
        let prev_meta_data = this.props.explore_meta_data;
        if(assert_key(prev_meta_data, [dataset])){
            // Data has loaded.
            return;
        }
        this.props.changeExploreLoading(true);
        const data_package = await getExploreIndividualData(dataset);

        if(data_package["success"] === true){
            let data_package_spec = [{
                "n": "data",
                "c":[
                    {"n": dataset}
                ]
            }];
            let flag = assert_key_hier(data_package, data_package_spec, true, "individual_explore_data_package");
            if(flag){
                console.log("individual explore meta package", data_package);
                prev_meta_data[dataset] = data_package["data"][dataset];
                this.props.initExploreMetaData(prev_meta_data);
                this.props.changeExploreLoading(false);
                // this.props.initDatasetList(data_package["datasets"]["DatasetsList"]);
            }
        }
        
    }
    public async initData(){
        const data_package = await getData();
        /*const explore_package = await getExploreMetaData();
        const img_package = await getRawData();
        console.log("explore_package", explore_package);
        console.log("img_package", img_package);*/
        //console.log(datasetList_package);
        if(data_package["success"] === true){
            let data_package_spec = [{
                "n": "data",
                "c":[
                    {"n": "TaskNames"}
                ]
            }];
            let flag = assert_key_hier(data_package, data_package_spec, true, "data_package");
            if(flag){
                console.log("data package", data_package);
                this.props.initData(data_package["data"]);
                // this.props.initDatasetList(data_package["datasets"]["DatasetsList"]);
            }
        }
        
    }
    public async initDatasetList(){
        const datasetList_package = await getDatasetList();
        //console.log(datasetList_package);
        if(datasetList_package["success"] === true){
            let datasetList_package_spec = [{
                "n": "datasets",
                "c": [{
                    "n": "DatasetsList"
                }]
            }];
            let flag = assert_key_hier(datasetList_package, datasetList_package_spec, true, "datasetList_package");
            if(flag){
                this.props.initDatasetList(datasetList_package["datasets"]["DatasetsList"]);
            }
        }
        
    }
    // Handling the event of changing data selector. 
    public onTaskSelectorChange(value: number) {
        this.props.changeTask(value);
        this.props.clearIdInfo();
    }
    // Handling the event of changing data selector. 
    public onDatasetSelectorChange(value: number) {
        this.props.changeDataset(value);
        
        //this.props.clearIdInfo();
    }
    // Handling the event of changing data selector. 
    public onAPISelectorChange(value: number) {
        this.props.changeAPI(value);
        //this.props.clearIdInfo();
    }
    // Handling the event of changing data selector. 
    public onAPIListSelectorChange(value: any) {
        this.props.changeAPIList(value);
        //this.props.clearIdInfo();
    }
    public onModeSelectorChange(value: any) {
        this.props.changeMode(value);
        //this.props.clearIdInfo();
    }
    
    public render() {        
        console.log("api_id_list", this.props.api_id_list);
        let {data, task_id, dataset_id, explore_meta_data} = this.props;
        let task_list = extract_task_list(data);
        let dataset_list = extract_dataset_list(data, task_id);
        let api_list = extract_api_list(data, task_id);
        let mode_options_list = get_mode_options();
        let disabledAPISelector = api_list.length <= 0;
        let disabledDatasetSelector = dataset_list.length <= 0;
        let disabledTaskSelector = task_list.length <= 0;
        let disabledModeSelector = mode_options_list.length <= 0;
        let visibleModeSelector = false;
        let explore_meta_dataset_list = extract_explore_dataset_list(explore_meta_data);
        let selected_dataset_name = safe_extract_item_from_list(dataset_id, dataset_list);
        
        if(explore_meta_dataset_list.indexOf(selected_dataset_name)>=0){
            visibleModeSelector = true;
            if(selected_dataset_name!==""){
                this.initExploreIndividualData(selected_dataset_name);
            }
        }else{
            //disabledModeSelector = true;
            /*if(this.props.mode_id != 1){
                this.onModeSelectorChange(1);
            }*/
        }
        
        console.log("visible", visibleModeSelector, explore_meta_dataset_list, selected_dataset_name);
        let all_api_id_list:any = api_list.map((d:any, index:any)=>index+1);
        let select_all_state = setsAreEqual(new Set(all_api_id_list), new Set(this.props.api_id_list));
        let generateTaskSelector = (col_size:number) => {
            return <Col span={col_size}>
                    <Row>
                    Task:&nbsp;
                    </Row>
                    <Row>
                    <Select
                        //size={"small"}
                        placeholder="Select a Task"
                        value={this.props.task_id  || undefined}
                        style={{ width: '95%'}}
                        onChange={this.onTaskSelectorChange}
                        disabled={disabledTaskSelector}
                    >
                        {task_list.map((d:any, index:any)=>(
                            <Option value={index+1} key={index+1}>
                                {d}
                            </Option>
                        ))}
                    </Select>
                    </Row>
                </Col>
        }
        let generateAPISelector = (col_size:number) => {
            return <Col span={col_size}>
                    <Row>
                    API:&nbsp;
                    </Row>
                    <Row>
                    <Select
                        //size={"small"}
                        mode={"multiple"}
                        allowClear
                        placeholder="Select APIs"
                        value={this.props.api_id_list}
                        style={{ width: '95%'}}
                        onChange={this.onAPIListSelectorChange}
                        disabled={disabledAPISelector}
                        dropdownRender={allSelectValue => (
                            <div>
                            <div style={{ padding: '4px 8px 8px 8px', cursor: 'pointer' }}>
                                <Checkbox checked={select_all_state} onChange={(e) => {
                                // 判断 是否 选中
                                if(e.target.checked === true){
                                    this.onAPIListSelectorChange(all_api_id_list);
                                }else{
                                    this.onAPIListSelectorChange([]);
                                }
                                }}>All</Checkbox>
                            </div>
                            <Divider style={{margin:'0'}}/>
                            {/* Option 标签值 */}
                            {allSelectValue}
                            </div>
                        )}
                    >
                        {api_list.map((d:any, index:any)=>(
                            <Option value={index+1} key={index+1}>
                                {d}
                            </Option>
                        ))}
                    </Select>
                    </Row>
                </Col>
        }
        let generateDatasetSelector = (col_size:number) => {
            return <Col span={col_size}>
                        <Row>
                        Dataset:&nbsp;
                        </Row>
                        <Row>
                        <Select
                            //size={"small"}
                            placeholder="Select a dataset"
                            value={this.props.dataset_id  || undefined}
                            style={{ width: '95%'}}
                            onChange={this.onDatasetSelectorChange}
                            disabled={disabledDatasetSelector}
                            
                            >
                            {dataset_list.map((d:any, index:any)=>(
                                <Option value={index+1} key={index+1}>
                                    {d}
                                </Option>
                            ))}
                        </Select>
                        </Row>
                    </Col>
        }
        let generateModeSelector = (col_size:number, visible: boolean)=>{
            //if(visible){
                return <Col span={col_size}>
                    <Row>
                    Mode:&nbsp;
                    </Row>
                    <Row>
                    <Select
                        //size={"small"}
                        placeholder="Select a mode"
                        value={this.props.mode_id}
                        style={{ width: '95%'}}
                        onChange={this.onModeSelectorChange}
                        disabled={disabledModeSelector}
                        
                        >
                        {mode_options_list.map((d:any, index:any)=>(
                            <Option value={index+1} key={index+1}>
                                {d}
                            </Option>
                        ))}
                    </Select>
                    </Row>
                </Col>
            /*}else{
                return <div />
            }*/
        }
        

        let generate_horizontal_layout = () => {
            let col_size = 8;
            return <Row>
                {generateTaskSelector(col_size)}
                {generateAPISelector(col_size)}
                {generateDatasetSelector(col_size)}
            </Row>
        }
        let generate_veritical_layout = () => {
            let col_size = 24;
            return <Row>
                <Col span={col_size}>
                <Row>
                {generateTaskSelector(col_size)}

                </Row>
                <Row>
                {generateAPISelector(col_size)}
                </Row>
                <Row>
                {generateDatasetSelector(col_size)}
                </Row>
                </Col>
                
            </Row>
        }
        
        let breakpoint = 620;
        if(this.props.width>=breakpoint){
            console.log("horizontal width:", this.props.width);
            return generate_horizontal_layout();
        }else{
            return generate_veritical_layout();
        }
            
    }
}

